import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14460">
      <span className="sr-only" data-id="element-14461">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-14462">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-14463" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-14464" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-14465">
        <div className="flex gap-8" data-id="element-14466">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-14467">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14468" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14469">
        <div className="space-y-6" data-id="element-14470">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-14471">
            <div data-id="element-14472">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-14473" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-14474" />
            </div>
            <div data-id="element-14475">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-14476" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-14477" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-14478">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-14479" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-14480" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-14481">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-14482">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-14483" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-14484" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-14485">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-14486" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-14487" />
      </div>
    </div>;
}